/**
 * ACCareSettingService
 * Service for managing Counselling/Care module settings (key/value)
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for module setting operations (getAll + update)
 */
export class ACCareSettingService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ACCareSettingService.DEFAULT_SERVICE_PATH,
            basePath: ACCareSettingService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
ACCareSettingService.DEFAULT_SERVICE_PATH = 'ac-counselling';
ACCareSettingService.BASE_PATH = 'api/care-settings';
//# sourceMappingURL=ACCareSettingService.js.map